import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import Button from 'app/components/Button/ResetedButton';
import { updateTreeValue } from 'app/pages/EventsPage/utils';
import type { EventTreeValue, EventTreeChangeAction } from 'app/pages/EventsPage/types';

import EventTreeVideogame from './EventTreeVideogame';
import style from './style.scss';

interface Props {
  value: EventTreeValue;
  onChange: (value: EventTreeValue) => void;
}

const EventTree: FC<Props> = ({ value, onChange }) => {
  const [t] = useTranslation();

  const handleChange = (action: EventTreeChangeAction) => {
    const newValue = updateTreeValue(value, action);
    onChange(newValue);
  };

  const selectAll = () => {
    handleChange({ type: 'EVENT_TREE_SELECT_ALL' });
  };

  return (
    <div className={style.container}>
      <Button className={style.allButton} onClick={selectAll}>
        {t('events-filter-all')}
      </Button>
      <div>
        {value.videogames.map(videogame => (
          <EventTreeVideogame key={videogame.key} value={videogame} dispatchChange={handleChange} />
        ))}
      </div>
    </div>
  );
};

EventTree.displayName = 'EventTree';

export default EventTree;
